var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"changeCourses"},[_vm._v(" 换课申请页面 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }